import { render, staticRenderFns } from "./PromedioContrato.vue?vue&type=template&id=3da9d3e0&"
import script from "./PromedioContrato.vue?vue&type=script&lang=js&"
export * from "./PromedioContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports